import PropTypes from 'prop-types';

import {
  privilegesPictos,
  privilegesToDomainState,
} from '../utils';

import Row from './display/Row';
import SvgColorImg from './SvgColorImg';

// Color per granted level: grey (none) → green (full).
// Max level of a domain is always LEVEL_MAX_COLOR; index 0 is always grey;
// intermediate levels spread across LEVEL_PALETTE[1..len-1] by position.
const LEVEL_MAX_COLOR = '#1a7d37';
const LEVEL_PALETTE = [
  '#c0c5cc', // 0: none - muted grey
  '#7b8fa8', // 1: slate - minimal
  '#5a9ea6', // 2: teal - low
  '#3a9a6b', // 3: green-teal - moderate
  '#27864a', // 4: medium green - high
];

const levelColor = (levelIdx, maxIdx) => {
  if (levelIdx === 0) return LEVEL_PALETTE[0];
  if (levelIdx >= maxIdx) return LEVEL_MAX_COLOR;

  const paletteRange = LEVEL_PALETTE.length - 1;
  const pIdx = 1 + Math.round(((levelIdx - 1) / (maxIdx - 1)) * (paletteRange - 1));
  return LEVEL_PALETTE[pIdx];
};

function PrivilegesIcons(props) {
  const {
    privileges,
    domains,
    onlyGranted = false,
    translate,
  } = props;
  const domainState = privilegesToDomainState(privileges || []);

  const shownDomains = onlyGranted
    ? domains.filter((domain) => {
        const ds = domainState[domain.domain];
        return (ds?.levelIndex > 0)
            || domain.toggles.some((toggle) => ds?.toggles[toggle.code]);
      })
    : domains;

  return (
    <Row className="flex-wrap p-1">
      {shownDomains.map((domain) => {
        const ds = domainState[domain.domain];
        const color = levelColor(ds?.levelIndex || 0, domain.levels.length - 1);

        return (
          <SvgColorImg
            key={domain.domain}
            src={privilegesPictos[domain.domain] || '/images/svg/gui/question.svg'}
            imgColor={color}
            className="w-5 h-5"
            description={translate(domain.labelKey, 'privileges')}
          />
        );
      })}
      {shownDomains.map((domain) => {
        const ds = domainState[domain.domain];

        return domain.toggles.map((toggle) => {
          const active = !!ds?.toggles[toggle.code];
          if (onlyGranted && (!active)) return null;

          return (
            <SvgColorImg
              key={toggle.code}
              src={privilegesPictos[toggle.code] || '/images/svg/gui/question.svg'}
              imgColor={active ? LEVEL_MAX_COLOR : LEVEL_PALETTE[0]}
              className="w-5 h-5"
              description={translate(toggle.labelKey, 'privileges')}
            />
          );
        });
      })}
    </Row>
  );
}

PrivilegesIcons.propTypes = {
  privileges: PropTypes.arrayOf(PropTypes.string),
  // Subset of privilegeDomains to render
  domains: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // When true, only render domains/toggles that are actually granted
  onlyGranted: PropTypes.bool,
  translate: PropTypes.func.isRequired,
};

export default PrivilegesIcons;
